import React from "react";
import {
  getNumberInputValue,
  getNumberOrUndefinedFromString,
} from "../../../../utils/inputUtils";
import InputTextApollo from "../../../inputs/InputTextApollo";
import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const AutomationSuiteRobotsProductWidget = ({
  product,
  onRemove,
  onProductChange,
  showDetails,
}: any) => {

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    if (product?.properties && name) {
      const productCopy = { ...product };
      productCopy.properties = { ...productCopy.properties };
      productCopy.properties[name] = getNumberOrUndefinedFromString(value);
      onProductChange(productCopy);
    }
  };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      showDetails={showDetails}
    >
      <FlexSection>
        <InputTextApollo
          label="Small Robots"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "concurrentSmallRobots",
            value: getNumberInputValue(product.properties.concurrentSmallRobots),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Standard Robots"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "concurrentStandardRobots",
            value: getNumberInputValue(product.properties.concurrentStandardRobots),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Medium Robots"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "concurrentMediumRobots",
            value: getNumberInputValue(product.properties.concurrentMediumRobots),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Large Robots"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "concurrentLargeRobots",
            value: getNumberInputValue(product.properties.concurrentLargeRobots),
            onChange: handleInputChange,
          }}
        />
      </FlexSection>
    </ProductWidgetContainer>
  );
};

export default AutomationSuiteRobotsProductWidget;
